import React from 'react';
import {isQuestionAnswered} from '../../../../../../data/filters/enrichments/isQuestionAnswered';
import { useProfileEnrichments } from '../../../../../../data/hooks/enrichments/useProfileEnrichments';
import {useI18n} from '../../../../../../data/hooks/i18nHooks';
import StartNetworkingStep from '../../../StartNetworkingStep/StartNetworkingStep';

/**
 * Renders the step where user can add their profile answers
 *
 * @param {Object} props - The props object
 * @param {number} props.eventId - The ID of the event.
 * @return {JSX.Element} The rendered StepProfileQuestions component.
 */
function StepProfileQuestions(props) {
    const {eventId} = props,
        i18n = useI18n(),
        questions = useProfileEnrichments(eventId),
        hasQuestions = !!questions.length,
        hasUnansweredQuestions = questions.filter(isQuestionAnswered).length > 0;

    return (
        <StartNetworkingStep href="./enrichments/1" visible={hasQuestions} done={hasUnansweredQuestions} complete={hasUnansweredQuestions}>
            {i18n['start.complete_profile']}
        </StartNetworkingStep>
    );
}

export default StepProfileQuestions;
